import type { UserProfilePatchInput } from '@today/models'
import type { UserProfileDto } from '@today/types'
import { apiClient } from './api.client'

const PROFILE = '/users/me/profile'

/** The signed-in user's own settings (TO-197 user-self-service-settings). */
export const userProfileService = {
	/** `GET /users/me/profile`. */
	async get(): Promise<UserProfileDto> {
		const { data } = await apiClient.get<UserProfileDto>(PROFILE)
		return data
	},

	/** `PATCH /users/me/profile` — partial; `null` resets a field. */
	async patch(body: UserProfilePatchInput): Promise<UserProfileDto> {
		const { data } = await apiClient.patch<UserProfileDto>(PROFILE, body)
		return data
	},

	/** `DELETE /users/me/sessions` — log out everywhere, this session included (204). */
	async revokeSessions(): Promise<void> {
		await apiClient.delete('/users/me/sessions')
	},
}
